import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { DialogueVo } from "../data/dialogue/dialoguevo";
import { IncidentSelector2Vo } from "../data/incident-selector2-vo";
import { Subject } from "rxjs";
import { IncidentGroupVo } from "../data/incident-group-vo";
import { IncidentVo } from "../data/incident-vo";
import { last } from "rxjs/operators";
import { DropdownData } from "src/app/data/dropdowndata";
import { KindVo } from "../data/kind-vo";

@Injectable({
  providedIn: "root",
})
export class IncidentSelectorService {
  eventTypeData: DropdownData[] = [];
  stateTypeData: DropdownData[] = [];
  agencyTypeData: DropdownData[] = [];
  agencyTypeDataStandard: DropdownData[] = [];
  kindTypeData: DropdownData[] = [];
  organizationTypeData: DropdownData[] = [];

  resourceAgencyTypeData: DropdownData[] = [];
  resourceJetportTypeData: DropdownData[] = [];
  resourceKindTypeData: DropdownData[] = [];
  resourceUnitTypeData: DropdownData[] = [];
  resourceIncidentTypeData: DropdownData[] = [];
  resourceIncAcctCodeTypeData: DropdownData[] = [];
  resourceAccrualCodeTypeData: DropdownData[] = [];

  kindVos: KindVo[];

  riuVos = [];
  tnspKindTypeData: DropdownData[] = [];
  tnspUnitTypeData: DropdownData[] = [];

  customReportsAgencyTypeData: DropdownData[] = [];
  customReportsJetportTypeData: DropdownData[] = [];
  customReportsKindTypeData: DropdownData[] = [];
  customReportsUnitTypeData: DropdownData[] = [];

  // selected row from incidents grid
  selectedGridRow: IncidentSelector2Vo = <IncidentSelector2Vo>{};
  selectedIncidentSelectorVo = new Subject<IncidentSelector2Vo>();

  // session context to keep track of iap print/preview plan order
  iapPrintPlanSessionState = [];

  // current working oject for incident group and incident
  // need to have this object as temporary solution so
  // the incgroup/inc child components have a default vo in their init methods
  currentVo: any;

  // isManageAsGroup and selectedDropdownIncidentId are holders for the
  // selected incidentId/group from the nav bar
  isManagedAsGroup = true;
  selectedDropdownIncidentId;

  // selectedTab is main nav selected tab (incidents, check-in, demob, time, ....)
  selectedTab: string;

  // selectedSubTab is tab within the main selecetd area
  selectedSubTab: string;

  currentResourceTab = new Subject<string>();

  iapSettingUpdated = false;
  iapSettingsChanged = new Subject<string>();
  tnspSettingsChanged = new Subject<string>();

  /*
    resourcesMode
    This variable holds the current mode of resources area.
    The following are the options:
       resview
       timeview
       adjview
       costview
  */
  resourcesMode: string;

  constructor(private http: HttpClient) {}

  reset() {
    const incSelectorVo = <IncidentSelector2Vo>{ id: 0 };
    this.iapPrintPlanSessionState = [];
    this.isManagedAsGroup = false;
    this.setSelectedIncidentSelectorVo(incSelectorVo);
    this.selectedGridRow = incSelectorVo;
  }

  setIsManagedAsGroup(val: boolean) {
    this.isManagedAsGroup = val;
  }

  setCurrentResourceTab(name) {
    this.currentResourceTab.next(name);
  }

  getCurrentResourceTab(): string {
    let name = "";
    this.currentResourceTab.pipe(last()).subscribe((d) => {
      name = Object.assign({}, d);
    });
    return name;
  }

  setIapSettingsChanged(val) {
    this.iapSettingsChanged.next(val);
  }

  getIapSettingsChanged(): string {
    let val = "";
    this.iapSettingsChanged.pipe(last()).subscribe((d) => {
      val = Object.assign({}, d);
    });
    return val;
  }

  setTnspSettingsChanged(val) {
    this.tnspSettingsChanged.next(val);
  }

  getTnspIapSettingsChanged(): string {
    let val = "";
    this.tnspSettingsChanged.pipe(last()).subscribe((d) => {
      val = Object.assign({}, d);
    });
    return val;
  }

  setSelectedDropdownIncidentId(id: number) {
    this.selectedDropdownIncidentId = id;
  }

  setSelectedIncidentSelectorVo(vo: IncidentSelector2Vo) {
    this.selectedIncidentSelectorVo.next(vo);
  }

  getSelectedIncidentSelectorVo(): IncidentSelector2Vo {
    let vo: IncidentSelector2Vo;
    this.selectedIncidentSelectorVo.pipe(last()).subscribe((d) => {
      vo = Object.assign({}, d);
    });
    return vo;
  }

  getGrid(userId): Observable<DialogueVo> {
    // TODO: Provide HTTP query params for incidentId, incidentGroupId, incidentsOnly and filterExcluded if desired.
    return this.http.get<DialogueVo>(`/service/users/${userId}/incidents/grid`);
  }

  getCustomUserIncDataView(userId): Observable<DialogueVo> {
    return this.http.get<DialogueVo>(
      `/service/users/${userId}/incidents/custom-view`
    );
  }
  getAllIncidentsForUser(userId, showAll): Observable<DialogueVo> {
    return this.http.get<DialogueVo>(
      `/service/incidents/current-user/${userId}/${showAll}`
    );
  }

  saveCustomUserIncDataView(userId, vos): Observable<DialogueVo> {
    const data = {
      incidentSelector2Vos: vos,
    };
    return this.http.post<DialogueVo>(
      `/service/users//${userId}/incidents/custom-view`,
      data
    );
  }
}
